import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { signIn, userRole } from '../services/auth/signIn';

const initialState = {
  id: null,
  name: '',
  email: '',
  role: '',
  currency: '',
  isActive: false,
  sessionCount: 0,
  createdAt: '',
  loading: false,
  error: null,
  status: ''
};

export const loginUser = createAsyncThunk(
  'user/loginUser',
  async ({ email, password }) => {
    const response = await signIn(email, password);
    console.log('Login Response:', response);
    return response.data;
  }
);


export const fetchUserRole = createAsyncThunk(
  'user/fetchUserRole',
  async (token, { rejectWithValue }) => {
    try {
      const response = await userRole(token);

      if (response.status === 401) {
        return rejectWithValue({ message: 'Unauthorized', status: 401 });
      }

      return response;
    } catch (error) {
      return rejectWithValue(
        error.response 
          ? error.response.data
          : { message: error.message }
      );
    }
  }
);



const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUser: (state) => {
      state.id = null;
      state.name = '';
      state.email = '';
      state.role = '';
      state.currency = '';
      state.isActive = false;
      state.sessionCount = 0;
      state.createdAt = '';
      state.status = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.errorRes = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.email = action.payload.email;
        state.errorRes = null;
        localStorage.setItem('access_token', JSON.stringify(action.payload.access_token));
        localStorage.setItem('refresh_token', JSON.stringify(action.payload.refresh_token));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchUserRole.fulfilled, (state, action) => {
        
        const { id, name, email, role, is_active, session_count, created_at, currency, status } = action.payload;
        state.id = id;
        state.name = name;
        state.email = email;
        state.role = role;
        state.currency = currency;
        state.isActive = is_active;
        state.sessionCount = session_count;
        state.createdAt = created_at;
        state.status = status;
        state.errorRes = null;
      })
      .addCase(fetchUserRole.rejected, (state, action) => {
        state.error = action.error.message;
        state.errorRes = action.payload?.status || null;
      });
  },
});

export const { clearUser } = userSlice.actions;
export default userSlice.reducer;
